import useCountdown from "../../hooks/useCountdown";

export default function NextSlideCountdown({
  initialSeconds = 5,
  label = "Next in...",
  size = 1.5
}) {
  // Usa hook de countdown baseado em timestamp
  const seconds = useCountdown(initialSeconds, initialSeconds != null && initialSeconds > 0);

  // valores relativos baseados no tamanho
  const baseHeight = 40 * size;
  const fontSize = 16 * size;
  const pillPaddingY = 6 * size;
  const pillPaddingX = 18 * size;
  const gap = 8 * size;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: `${gap}px`,
        width: "fit-content",
      }}
    >
      {/* pill branca */}
      <div
        style={{
          backgroundColor: "#FAF6EC",
          color: "#333",
          borderRadius: "9999px",
          padding: `${pillPaddingY}px ${pillPaddingX * 2}px ${pillPaddingY}px ${pillPaddingX}px`,
          fontSize: `${14 * size}px`,
          fontWeight: 500,
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          lineHeight: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {label}
      </div>

      {/* bolinha amarela encaixada */}
      <div
        style={{
          marginLeft: `${-baseHeight * 0.9}px`,
          flexShrink: 0,
        }}
      >
        <div
          style={{
            backgroundColor: "#FDBE2D",
            color: "white",
            fontWeight: "bold",
            fontSize: `${fontSize}px`,
            width: `${baseHeight}px`,
            height: `${baseHeight}px`,
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 2px 4px rgba(0,0,0,0.15)",
          }}
        >
          {seconds}
        </div>
      </div>
    </div>
  );
}
